import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, TextField } from '@mui/material';
import React, { ReactElement } from 'react';

type InputProps = {
  placeHolder?: string;
  className?: string;
  onChange?: (src: any) => void;
  onBlur?: (src: any) => void;
  autoFocus?: boolean;
  extraStyle?: any;
  extraStyle1?: any;
  extraInputStyle?: any;
  extraInputBaseStyle?: any;
  value?: string;
  variant?: any;
  error?: any;
  name?: string;
  type?: string;
  inputProps?: any;
  id?: string;
  maxLength?: number;
  isTextArea?: boolean;
  disabled?: boolean;
  minRows?: number;
  from?: string;
};

const CustomInput = React.forwardRef(
  (props: InputProps, ref: any): ReactElement => {
    const [showPassword, setShowPassword] = React.useState<boolean>(false);

    const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (
      event: React.MouseEvent<HTMLButtonElement>,
    ) => {
      event.preventDefault();
    };

    const {
      placeHolder,
      className,
      onChange,
      onBlur,
      autoFocus = false,
      extraStyle,
      extraInputStyle,
      extraInputBaseStyle,
      value,
      variant,
      error,
      name = '',
      type = 'text',
      inputProps = {},
      id = '',
      maxLength,
      isTextArea = false,
      disabled,
      minRows = 3,
      from,
    } = props;

    return (
      <>
        <TextField
          placeholder={variant ? '' : placeHolder}
          label={variant ? placeHolder : ''}
          className={className}
          onChange={onChange && onChange}
          autoFocus={autoFocus}
          onBlur={onBlur && onBlur}
          name={name}
          disabled={disabled}
          ref={ref}
          id={id}
          style={extraStyle}
          value={value}
          variant={variant}
          error={error}
          helperText={error}
          type={showPassword ? 'text' : type}
          InputProps={{
            ...inputProps,
          }}
          inputProps={{
            maxLength: maxLength,
          }}
          multiline={isTextArea ? true : false}
          minRows={isTextArea ? (minRows ? minRows : 3) : 1}
          maxRows={isTextArea ? 3 : 1}
          sx={{
            '& .MuiInputBase-formControl':
              from === 'leave'
                ? {
                    padding: '0px !important',
                    paddingTop: '10px !important',
                  }
                : extraInputBaseStyle
                ? extraInputBaseStyle
                : {},
            '& input': extraInputStyle ? extraInputStyle : {},
          }}
        />
        {type === 'password' && (
          <IconButton
            style={{ position: 'absolute', right: '10%', ...props.extraStyle1 }}
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            edge="end">
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        )}
      </>
    );
  },
);

export default CustomInput;
